// extracted by mini-css-extract-plugin
export default {"paneBody":"paneBody---VmXRc","searchResults":"searchResults---Fx3sT"};